import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-102" data-mp="124po93oct9gw">
      <div className="mx-auto w-full max-w-2xl" data-id="element-103" data-mp="1pt8xpmj53sak">
        <SectionHeading tone="light" eyebrow="FAQ" title="Domande frequenti" data-id="element-104" data-mp="1puk29oket42q" />

        <ul className="mt-8 space-y-2.5" data-id="element-105" data-mp="1uqiy1x82hod6">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-ink/10 bg-white" data-id="element-106" data-mp="1l0pkiqod6z6a" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-107" data-mp="28oz3zly3vau9">
                  <span className="text-[14.5px] font-bold leading-snug text-ink" data-id="element-108" data-mp="2jsyyivfvzfi2">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-gold-dark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-109" data-mp="2tplgncgtvsge" />
                </button>
                <AnimatePresence initial={false} data-id="element-110" data-mp="3hemmcrya0phz">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-111" data-mp="3cftfvjhepyrb">
                      <p className="px-5 pb-4 text-[14px] leading-relaxed text-ink/65" data-id="element-112" data-mp="27q7eqxistv05">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-113" data-mp="2lpfg9x2fpf7i">
          <CTAButton label="Ho tutte le risposte, voglio iniziare" data-id="element-114" data-mp="2lra2rftctfdp" />
        </div>
      </div>
    </section>;
}